import { useState } from "react";
import { Button } from "../ui/button";
import { Textarea } from "../ui/textarea";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "../ui/dialog";

export function ReasonDialog({ open, title, description, confirmLabel = "Confirmar", danger, onClose, onConfirm, testid = "reason-dialog" }) {
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  const go = async () => { setBusy(true); try { await onConfirm(reason.trim()); setReason(""); } finally { setBusy(false); } };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid={testid}>
        <DialogHeader><DialogTitle>{title}</DialogTitle>{description && <DialogDescription>{description}</DialogDescription>}</DialogHeader>
        <Textarea rows={3} value={reason} onChange={(e) => setReason(e.target.value)} placeholder="Motivo (obrigatório — fica registrado no histórico)" data-testid={`${testid}-reason`} />
        <DialogFooter>
          <Button variant="outline" onClick={onClose} data-testid={`${testid}-cancel`}>Voltar</Button>
          <Button disabled={busy || reason.trim().length < 3} onClick={go} className={danger ? "bg-rose-600 hover:bg-rose-700" : ""} data-testid={`${testid}-confirm`}>{confirmLabel}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>);
}
